import {
  trackDocumentFieldClick,
  trackVisitTime,
  trackVideo,
  trackContentLinkBlockClick,
} from '@signing-page/api/tracking/graphql/tracking.mutations';
import { apolloClient } from '@signing-page/apollo';

export default class TrackingService {
  static async trackFieldClick(id: string): Promise<boolean> {
    const { data } = await apolloClient.mutate({
      mutation: trackDocumentFieldClick,
      variables: {
        id,
      },
    });
    return data.trackDocumentFieldClick;
  }

  static async trackVisitTime(
    pageNum: number,
    pageTimeMillis: number,
    documentPageId: string,
    revision?: number
  ): Promise<boolean> {
    const { data } = await apolloClient.mutate({
      mutation: trackVisitTime,
      variables: {
        pageNum,
        pageTime: pageTimeMillis,
        pageId: documentPageId,
        revision,
      },
    });
    return data.trackVisitTime;
  }

  static async trackVideo(id: string, viewDuration: number): Promise<boolean> {
    const { data } = await apolloClient.mutate({
      mutation: trackVideo,
      variables: {
        videoId: id,
        viewDuration,
      },
    });
    return data.trackVideo;
  }

  static async trackContentLinkBlockClick(id: string): Promise<boolean> {
    const { data } = await apolloClient.mutate({
      mutation: trackContentLinkBlockClick,
      variables: {
        id,
      },
    });
    return data.trackContentLinkBlockClick;
  }
}
